import { render, staticRenderFns } from "./SetSafePasswordDialog.vue?vue&type=template&id=9c8b6aca"
import script from "./SetSafePasswordDialog.vue?vue&type=script&lang=js"
export * from "./SetSafePasswordDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports